import styled from 'styled-components';

const StyledFallBack = styled.div``;

export function SupportFallback(props) {
  return (
    <StyledFallBack>
      <div style={{ color: 'red' }}>!!!</div>
    </StyledFallBack>
  );
}

export default SupportFallback;
